import {inject, Injectable} from "@angular/core";
import {ActionService, ConfigurationService, JwtHttpClientService, ResourceModule} from "@fedelta-pos/data-client";

/**
 * Service for order transfer
 */
@Injectable({providedIn: "root"})
export class OrderTransferService extends ActionService {
    constructor() {
        const http: JwtHttpClientService = inject(JwtHttpClientService);
        const configService: ConfigurationService = inject(ConfigurationService);
        const nameSpace: string = inject<string>(ResourceModule.RESOURCE_NAMESPACE_KEY);
        const actionNames: string[] = inject<string[]>(ResourceModule.ACTION_NAMES_KEY);
        const useAsync: boolean = inject<boolean>(ResourceModule.RESOURCE_USE_ASYNC);

        console.log("--- OrderTransferService");

        super(http, nameSpace, "app-order-transfer", configService, useAsync, actionNames);
    }
}
